<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // 注册监听全局的clearKeepAlive方法,可在其他组件中触发此方法
  },
};
</script>

<style>
@import "./assets/styles/reset.css";
</style>



// WEBPACK FOOTER //
// src/App.vue